var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.571,
    height: 108.571,
    viewBox: "0 0 108.571 108.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.503,
    cy: 0.336,
    fy: -0.6525803208351135,
    r: 1.374,
    gradientTransform: "translate(0 0.172) scale(1 0.489)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#00afe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#0c98d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378,
    stopColor: "#1b7bbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2766ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2d5aa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#3056a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193684"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(-135.215 -208.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 108.571,
    height: 108.571,
    rx: 10.998,
    transform: "translate(135.215 208.574)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M215.089,241.565H209.5a19.983,19.983,0,0,0-39.607,0h-5.985a12.5,12.5,0,0,0-12.482,12.482v31.3a12.5,12.5,0,0,0,12.482,12.483h51.178a12.5,12.5,0,0,0,12.482-12.483v-31.3A12.5,12.5,0,0,0,215.089,241.565ZM189.7,229.615a14.651,14.651,0,0,1,14.378,11.95H175.321A14.651,14.651,0,0,1,189.7,229.615Zm32.511,55.73a7.131,7.131,0,0,1-7.122,7.123H163.911a7.131,7.131,0,0,1-7.122-7.123v-31.3a7.13,7.13,0,0,1,7.122-7.122h51.178a7.13,7.13,0,0,1,7.122,7.122Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M200.379,265.676H193.72v-6.659a4.02,4.02,0,1,0-8.04,0v6.659h-6.66a4.02,4.02,0,1,0,0,8.04h6.66v6.66a4.02,4.02,0,0,0,8.04,0v-6.66h6.659a4.02,4.02,0,1,0,0-8.04Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3d2c39011a2cda571c6f9fca3a56e89c.svg";
export { ForwardRef as ReactComponent };